module.exports = __webpack_public_path__ + "media/country_flags/ky-dd5f23b8.png";